import { debounce } from './utils';

export default function valueChain() {
    return {
        setContainerSize() {
            const container = this.$el;
            const minSize = 220;
            const maxSize = 520;
            const parent = container?.parentElement
            const parentWidth = parent.clientWidth ?? window.innerWidth
            const size = Math.max(minSize, Math.min(parentWidth* 0.8, maxSize));
            container.style.width = `${size}px`;
            container.style.height = `${size}px`;
        },
        positionElements() {
            const container = this.$el;
            const items = container.querySelectorAll('.c-item');
            const arrows = container.querySelectorAll('.c-arrow');
            const n = items.length;

            const rect = container.getBoundingClientRect();
            const containerSize = Math.min(rect.width, rect.height);

            let itemSize = 0;
            if (items[0]) {
                const itemRect = items[0].getBoundingClientRect();
                itemSize = Math.max(itemRect.width, itemRect.height);
            }

            const radius = (containerSize - itemSize) / 2 + itemSize / 2;
            const arrowRadius = radius * 0.8;

            items.forEach((el, i) => {
                const angle = (i / n) * 2 * Math.PI - Math.PI / 2;
                const x = Math.cos(angle) * radius;
                const y = Math.sin(angle) * radius;
                el.style.top = '50%';
                el.style.left = '50%';
                el.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px)`;
                el.style.animationDelay = `${i * 0.15}s`;
            });

            arrows.forEach((el, i) => {
                const angle = ((i + 0.5) / n) * 2 * Math.PI - Math.PI / 2;
                const x = Math.cos(angle) * arrowRadius;
                const y = Math.sin(angle) * arrowRadius;
                const deg = (angle * 180) / Math.PI + 90;
                el.style.top = '50%';
                el.style.left = '50%';
                el.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(${deg}deg)`;
                el.style.animationDelay = `${(i + items.length) * 0.15}s`;
            });
        },
          observeVisibility() {
            const container = this.$el;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        container.classList.add('is-in-viewport');
                    } else {
                        container.classList.remove('is-in-viewport');
                    }
                });
            }, { threshold: 0.1 });
            observer.observe(container);
        },
        init() {
            this.setContainerSize();
            setTimeout(() => {
                this.positionElements();
                this.observeVisibility();
            }, 10);

            const onResize = debounce(() => {
                this.setContainerSize();
                this.positionElements();
            }, 100);

            window.addEventListener('resize', onResize, { passive: true });
        },
    }
}
